<!-- 动态数据面板 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <!-- 内容设置 -->
                <div v-if="name_id == 1">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="100"
                    >
                        <div class="form-title">动态标题</div>
                        <FormItem label="标题文字">
                            <Input
                                v-model="newFormData.content.title"
                                placeholder="单行输入"
                            ></Input>
                        </FormItem>
                        <FormItem label="文字大小">
                            <Input
                                v-model="newFormData.content.title_size"
                                placeholder="请输入文字大小"
                                ><span slot="append">PX</span></Input
                            >
                        </FormItem>
                        <FormItem label="标题颜色">
                            <ColorPicker
                                v-model="newFormData.content.title_color"
                            />
                        </FormItem>
                        <FormItem label="装饰颜色">
                            <ColorPicker
                                v-model="newFormData.content.dec_color"
                            />
                        </FormItem>
                        <FormItem label="分割线颜色">
                            <ColorPicker
                                v-model="newFormData.content.title_border_color"
                            />
                        </FormItem>
                        <FormItem label="标题背景">
                            <ColorPicker
                                v-model="newFormData.content.title_bg_color"
                            />
                        </FormItem>

                        <div class="form-title">动态内容</div>
                        <FormItem label="文字大小">
                            <Input
                                v-model="newFormData.content.content_size"
                                placeholder="请输入文字大小"
                                ><span slot="append">PX</span></Input
                            >
                        </FormItem>
                        <FormItem label="标题颜色">
                            <ColorPicker
                                v-model="newFormData.content.content_color"
                            />
                        </FormItem>

                        <div class="form-title">查看权限</div>
                        <FormItem label="谁能查看">
                            <!-- 查看权限：who_type 0所有人/1全部成员/2指定成员，customer_ids 指定成员ID数组 -->
                            <RadioGroup
                                v-model="newFormData.content.who_type"
                                vertical
                            >
                                <Radio label="0" class="mb8">所有人</Radio>
                                <div class="perm-tip">
                                    公开后表单记录所有人可见，请确保合法合规，如涉及个人隐私请谨慎公开并开启隐私保护，根据《网络安全法》要求，平台将提示填写人授权手机号以完成实名验证
                                </div>
                                <Radio label="1" class="mb8 mt8"
                                    >全部成员</Radio
                                >
                                <Radio label="2" class="mb8">指定成员</Radio>
                            </RadioGroup>
                            <Select
                                class="mt8 w240"
                                v-if="newFormData.content.who_type == '2'"
                                v-model="newFormData.content.customer_ids"
                                multiple
                                filterable
                                placeholder="选择成员"
                            >
                                <Option
                                    v-for="m in memberOptions"
                                    :value="m.id"
                                    :key="m.id"
                                    >{{ m.name }}</Option
                                >
                            </Select>
                        </FormItem>

                        <div class="form-title">时间轴样式</div>
                        <FormItem label="轴线线式">
                            <RadioGroup v-model="newFormData.content.mode_id">
                                <Radio class="mr12" label="1">直线加圆点</Radio>
                                <Radio class="mr12" label="2">虚线</Radio>
                                <Radio class="mr12" label="3">直线</Radio>
                                <Radio class="mr12" label="4">直线加图片</Radio>
                                <Radio class="mr12" label="5">虚线加图片</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="轴线颜色">
                            <ColorPicker
                                v-model="newFormData.content.line_color"
                            />
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.mode_id == 1"
                            label="圆点颜色"
                        >
                            <ColorPicker
                                v-model="newFormData.content.circle_color"
                            />
                        </FormItem>
                        <FormItem
                            v-if="
                                newFormData.content.mode_id == 4 ||
                                newFormData.content.mode_id == 5
                            "
                            label="上传图片"
                        >
                            <div
                                class="bg-upload"
                                @click="openModal('mode_img')"
                            >
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.mode_img.picview"
                                    :src="newFormData.content.mode_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>

                        <div class="form-title">按钮设置</div>
                        <FormItem label="按钮颜色">
                            <ColorPicker
                                v-model="newFormData.content.btn_color"
                            />
                        </FormItem>
                        <FormItem label="边框颜色">
                            <ColorPicker
                                v-model="newFormData.content.border_color"
                            />
                        </FormItem>
                        <FormItem label="文字颜色">
                            <ColorPicker
                                v-model="newFormData.content.btn_text_color"
                            />
                        </FormItem>
                        <FormItem label="蒙版颜色">
                            <ColorPicker
                                v-model="newFormData.content.mask_color"
                            />
                        </FormItem>

                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker
                                v-model="newFormData.content.bg_color"
                            />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>

                <!-- 边距设置 -->
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
// customer_select：获取成员列表（查看权限-指定成员下拉使用）
import { customer_select } from "@/api/index";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            uploadKey: "bg_img",
            memberOptions: [],
        };
    },
    // 初始化：加载成员列表 + 兼容旧权限数据结构
    created() {
        this.getMemberList();
        this.ensurePermission();
    },
    methods: {
        // 加载成员下拉数据（查看权限-指定成员时使用）
        getMemberList() {
            customer_select()
                .then((res) => {
                    this.memberOptions = res.data || [];
                })
                .catch((err) => {
                    this.$Message.error(err.msg || "获取人员列表失败");
                });
        },
        // 保证查看权限字段存在（who_type/customer_ids）
        ensurePermission() {
            const content = this.newFormData.content;
            if (content.who_type == null) {
                this.$set(content, "who_type", "0");
            }
            if (!Array.isArray(content.customer_ids)) {
                this.$set(content, "customer_ids", []);
            }
        },
        selectName(name) {
            this.name_id = name;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        openModal(key) {
            this.uploadKey = key || "bg_img";
            this.switch_modal = true;
        },
        async costPlannedAmountChange(param1, param2) {
            const key = this.uploadKey;
            if (!this.newFormData.content[key]) {
                this.$set(this.newFormData.content, key, {
                    value: "",
                    picview: "",
                });
            }
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content[key].picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content[key].value = param2[i];
            }
            this.$Message.destroy();
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0 12px;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.mb8 {
    margin-bottom: 8px;
}
.mt8 {
    margin-top: 8px;
}
.mr12 {
    margin-right: 12px;
}
.w240 {
    width: 240px;
}
.perm-tip {
    color: #999;
    font-size: 12px;
    line-height: 1.6;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: #ff761d;
}
::v-deep .ivu-radio-inner:after {
    background-color: #ff761d;
}
::v-deep .ivu-menu-horizontal .ivu-menu-item-active,
::v-deep .ivu-menu-horizontal .ivu-menu-item:hover,
::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active {
    color: #ff761d;
    border-bottom-color: #ff761d;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
</style>
